import React from "react";
import { formatChancePct } from "../../../utils/bondPredictHelpers";

const OutcomeNavItem = ({
  active = false,
  onClick,
  logo,
  label,
  hint,
  tone,
  probability,
  collapsed = false,
  dimmed = false,
  winner = false,
  disabled = false,
}) => {
  const pctLabel = formatChancePct(probability);

  return (
    <button
      type="button"
      className={`bp-predict-nav-item bp-outcome-nav-item${
        active ? " bp-predict-nav-item-on" : ""
      }${tone ? ` bp-outcome-nav-item-${tone}` : ""}${
        dimmed ? " bp-outcome-nav-item-dimmed" : ""
      }${winner ? " bp-outcome-nav-item-winner" : ""}`}
      aria-pressed={active}
      aria-label={label}
      title={collapsed ? `${label} · ${pctLabel}` : undefined}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="bp-predict-nav-item-indicator" aria-hidden />
      {logo ? (
        <span className="bp-predict-nav-item-crest">
          <img src={logo} alt="" />
        </span>
      ) : tone ? (
        <span className={`bp-outcome-nav-chip bp-outcome-nav-chip-${tone}`} aria-hidden>
          {label.slice(0, 3)}
        </span>
      ) : null}
      {!collapsed ? (
        <>
          <span className="bp-predict-nav-item-copy">
            <span className="bp-predict-nav-item-label">{label}</span>
            {hint ? <span className="bp-predict-nav-item-hint">{hint}</span> : null}
          </span>
          <span className="bp-outcome-nav-pct tabular-nums">{pctLabel}</span>
        </>
      ) : null}
    </button>
  );
};

export default OutcomeNavItem;
